<div class="top-bar flex flex-row items-center px-3">
  <h2>
    Loader Integration Analytics <span *ngIf="emailData$ | async; let emailData"> - {{ emailData.loaderName }}</span>
  </h2>
</div>

<div class="loader-analytics-component">
  <mat-radio-group aria-label="Select an option" [(ngModel)]="filter" (change)="filterTypeChange()">
    <mat-radio-button value="all">All</mat-radio-button>
    <mat-radio-button value="matched">Matched Only</mat-radio-button>
    <mat-radio-button value="unmatched">Unmatched Only</mat-radio-button>
  </mat-radio-group>

  <div class="table-wrap">
    <table mat-table [dataSource]="activeDataSource" matSort>
      <ng-container matColumnDef="uploadTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Upload Time</th>
        <td mat-cell *matCellDef="let load">
          {{ load.uploadTime | inTimezone: loaderTimezone }}
        </td>
      </ng-container>

      <ng-container matColumnDef="poNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>PO Number</th>
        <td mat-cell *matCellDef="let load">
          {{ load.poNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="bolNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>BOL Number</th>
        <td mat-cell *matCellDef="let load">
          {{ load.bolNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="pickupTime">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Pickup Time</th>
        <td mat-cell *matCellDef="let load">
          {{ load.pickupTime | inTimezone: loaderTimezone | dashIfNothing }}
        </td>
      </ng-container>

      <ng-container matColumnDef="truckNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Truck Number</th>
        <td mat-cell *matCellDef="let load">
          {{ load.truckNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="potentialMatchCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Potential Load Matches</th>
        <td
          mat-cell
          *matCellDef="let load"
          [routerLink]="['/loader-analytics-dashboard-v2', 'load', load.integrationDataId]"
          class="link-cell"
        >
          <a [routerLink]="['/loader-analytics-dashboard-v2', 'load', load.integrationDataId]">
            {{ load.potentialMatchCount }}
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="orderId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Matched Order ID</th>
        <td mat-cell *matCellDef="let load">
          <a [routerLink]="['/', 'lmo', 'frac', load.orderFracId, 'orders', load.orderId]">{{ load.orderId }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="matchReasons">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Match Reasons</th>
        <td mat-cell *matCellDef="let load">
          <div class="match-reasons">
            <ng-container *ngFor="let reason of load.matchReasons">
              <div *ngIf="toMatchReasonText(reason, load); let reasonText" class="match-reason">
                {{ reasonText }}
              </div>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let load; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
